const documentos = [
  {
    slug: "procesos-poc",
    titulo: "Procesos POC - Diagrama",
    pdf: "proceso-POC.pdf",
  },
  {
    slug: "procesos-poc-raci",
    titulo: "Procesos POC - Matriz RACI",
    pdf: "proceso-POC-RACI.pdf",
  },
  {
    slug: "mantenimiento-preventivo",
    titulo: "Mantenimiento Preventivo",
    pdf: "ingenieria-mantenimiento-preventivo-total.pdf",
  },
  {
    slug: "mantenimiento-correctivo",
    titulo: "Mantenimiento Correctivo",
    pdf: "ingenieria-mantenimiento-correctivo.pdf",
  },
];

export default documentos;
